import { useInfiniteQuery } from "@tanstack/react-query";
import ehjzleeInstance from "./ehjzleeInstance";
import config from "./config";

export const useGetWeekendOffers = () => {
  const q = useInfiniteQuery<{
    page: number;
    size: number;
    count: number;
    pagesCount: number;
    properties: Property[];
  }>({
    queryKey: ["weekend-offers"],
    queryFn: ({ pageParam }) => getWeekendOffers(Number(pageParam)),
    initialPageParam: 1,
    getNextPageParam: (params) => {
      let page = params?.page;
      return page >= params?.pagesCount ? undefined : ++page;
    },
  });

  return q;
};

const getWeekendOffers = async (page: number, size: number = 12) => {
  try {
    const res = await ehjzleeInstance.get(`${config.props}/weekend-offers`, {
      params: { page, size },
    });
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
